import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { motion } from "framer-motion";

const testimonials = [
  {
    name: "Mukesh Chaudhary",
    role: "farmer",
    image: "/testimonial.png",
    feedback: "वसुंधरा सीट पर बहुत अच्छी क्वालिटी के गेहूं उपलब्ध होते हैं"
  },
  {
    name: "आजाद चौरसिया",
    role: "Farmer",
    image: "/testimonial.png",
    feedback: "बीच के मामले में गुणवत्ता के साथ विश्वास ही वसुंधरा की पहचान है हमारे उज्जैन के लिए बहुत ही सम्मान का विषय है उज्जैन की शान वसुंधरा सीड्स, किसान का विश्वास वसुंधरा सीड्स की पहचान..🚩जय श्री महाकाल🚩 …"
  },
  {
    name: "Deepak Borkar",
    role: "Farmer",
    image: "/testimonial.png",
    feedback: "Good people always their to help farmers with latest innovations."
  },
  {
    name: "Vaibhav Patidar",
    role: "Farmer",
    image: "/testimonial.png",
    feedback: "Best seeds of mp are available here"
  }
];

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextTestimonial();
    }, 5000); // Auto-scroll every 5 seconds
    return () => clearInterval(interval);
  }, [currentIndex]);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  return (
    <section className="bg-gray-100 py-12 px-6 ">

      <div className="container mx-auto text-center">
        <div className="flex justify-center"><h2 className="text-3xl font-bold text-gray-800 border-b-2 border-yellow-900">Testimonials</h2></div>
        <p className="text-gray-600 mb-8">Hear from our satisfied customers</p>

        <div className="relative flex justify-center items-center">
          {/* Left Button */}
          <button
            className="absolute left-0 bg-white p-3 rounded-full shadow-lg hover:bg-gray-200 transition-all"
            onClick={prevTestimonial}
          >
            <ChevronLeft size={24} />
          </button>

          {/* Testimonial Card */}
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
            className="mx-6 max-w-lg rounded-xl border border-gray-200 bg-gradient-to-br from-white to-gray-100 p-6 text-center shadow-sm"
          >
            <img
              src={testimonials[currentIndex].image}
              alt={testimonials[currentIndex].name}
              className="w-16 h-16 rounded-full mx-auto mb-3"
            />
            <p className="text-lg font-semibold italic text-gray-800">"{testimonials[currentIndex].feedback}"</p>
            <h3 className="mt-4 text-lg font-semibold text-green-900">{testimonials[currentIndex].name}</h3>
            <p className="text-sm text-gray-600">{testimonials[currentIndex].role}</p>
          </motion.div>

          {/* Right Button */}
          <button
            className="absolute right-0 bg-white p-3 rounded-full shadow-lg hover:bg-gray-200 transition-all"
            onClick={nextTestimonial}
          >
            <ChevronRight size={24} />
          </button>
        </div>

        {/* Navigation Dots */}
        <div className="flex justify-center mt-6 space-x-2">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full ${currentIndex === index ? "bg-green-900" : "bg-stone-400"
                } transition-all`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
